import styled from 'styled-components';

export const Loading = styled.div`
  position: absolute;
`;

export default { Loading };
